/**
 * This function is responsible for executing the given {@link block}, e.g. for requesting specific data.
 */
export const request = (block: () => void) => {
  block();
};
